export const REGISTRATION_ERRORS = {
	firstName: 'Please enter your first name.',
	lastName: 'Please enter your last name.',
	email: 'Please enter your email address.',
	emailValidation: 'Please enter a valid email address.',
	password: 'Please enter your new password.',
	passwordComplexity: 'Please make sure your password follows the password requirements.',
	confirmPassword: 'Please confirm your password.',
	passwordMismatch: 'Passwords do not match.',
	policyNumber: 'Please enter your policy number you have with us.',
	policyNumberValid: 'Please enter a valid policy number.',
	dateOfBirth: 'Please enter your date of birth.',
	postCode: 'Please enter your postcode',
	vehicleRegistrationNumber: 'Please enter the vehicle registration which is on cover.',
	companyTradingName: 'Please enter your Company Name.',
	dateEstablished: 'Please enter the date your company was established',
	staffContact: 'Please enter the primary staff contact name',
};

export const PASSWORD_CHANGE_ERROR = {
	newPassword: 'Please enter your new password.',
	passwordComplexity:
		'Password must be at least 8 characters long and contain an uppercase letter, a lowercase letter, a number, a special character.',
	newPasswordConfirmation: 'Please confirm your password.',
	passwordMismatch: 'Passwords do not match.',
};

export const ADDRESS_ERRORS = {
	postcodeValid: 'Please enter a valid postcode',
	postCodeRequired: 'Please enter your postcode',
	line1: 'Please enter the first line of your address',
	city: 'Please enter a city',
	searched: 'Please select an address',
	isCorrect: 'Please select if the details are correct',
};

export const PAYMENT_ERRORS = {
	vendorType: "Sorry we don't support this card vendor, please try Visa or Mastercard.",
	preparing: 'There was a problem preparing your payment.',
};

export const CARD_PAYMENT_FROM_ERRORS = {
	billingDetails: 'Please select if the billing details match the policyholder details',
	cardholderFirstNameRequired: 'Cardholder first name is a required field',
	cardholderLastNameRequired: 'Cardholder last name is a required field',
	cardholderFirstNameMinLength: 'Cardholder first name must be longer than 3 characters',
	cardholderFirstNameMaxLength: "Cardholder first name can't be longer than 50 characters",
	cardholderLastNameMinLength: 'Cardholder last name must be longer than 3 characters',
	cardholderLastNameMaxLength: "Cardholder last name can't be longer than 50 characters",
	cardholderNameSpecialChar: 'Cardholder name cannot begin or end with special characters or include numbers',
};

export const MTA_ADDRESS_CHANGE_ERRORS = {
	annualMileageGreaterThanZero: 'Annual Mileage must be greater than zero',
	annualMileageRequired: 'Please enter your annual mileage',
	businessMileageGreaterThanZero: 'Business Mileage must be greater than zero',
	businessMileageRequired: 'Please enter your annual business mileage',
	keptOvernight: 'Please verify where the vehicle is kept overnight',
	homeOwnerRequired: 'Please verify if you are a home owner or not',
	taxiBadgeType: 'Please select the type of badge you have',
	badgeObtained: 'Please select when you obtained your badge',
	hasLicensingAuthority: 'Please select your licensing authority',
	hasPrimaryOperatingArea: 'Please select your operating area',
	overnightAddressIsAwayRequired: 'Please verify where your vehicle is kept overnight',
	addressRequired: 'Please enter your address',
};

export const VEHICLE_DETAILS_PART_ONE_ERROR_MESSAGES = {
	emptyVrm: 'Please search for a vehicle by registration.',
	validRegistration: 'Please input a valid registration',
	registrationRequired: 'Vehicle Registration is required',
	registrationApiError: 'There was a problem searching, please try again',
	valueGreaterThanZero: 'Value must be greater than zero',
	valueMaxAmount: "Value can't greater than £1,000,000",
	valueRequired: 'Please enter the value of the vehicle',
	motorCyclesNotInsurable: 'Motorcycles, mopeds or scooters not insurable on this policy',
	vehicleTypeNotInsurable: 'Selected vehicle type is not insurable on this policy',
	sameVrm: "You can't use the same registration.",
};

export const MODIFICATION_ERROR_MESSAGES = {
	modificationCode: 'Please select the type of modification',
	valueRequired: 'Please enter the value of the modification',
	valueGreaterThanZero: 'Modification must be greater than zero',
	isForMedicalReasons: 'Please confirm if this was for medical reasons',
};

export const ADDITIONAL_DRIVER_ERRORS = {
	title: 'Please select their title',
	firstName: 'Please enter their first name',
	lastName: 'Please enter their last name',
	dateOfBirth: 'Please select their date of birth',
	minimumAge: 'Their date of birth must be at least 16 years ago',
	maritalStatus: 'Please select their marital status',
	relationshipToProposer: 'Please select their relationship to the proposer',
	relationshipToProposerConflict: 'The selected value conflicts with other information provided',
	isResidentFromBirth: 'Please confirm if they have lived in the UK since birth',
	ukResidenceSince: 'Please select their residence date',
	employmentType: 'Please select the type of employment they have',
	occupation: 'Please search for and select their main occupation',
	more: 'Please select the occupation',
	industry: 'Please search for and select their main industry',
	otherEmployment: 'Please confirm if they have another occupation',
	otherOccupation: 'Please search for and select their other occupation',
	otherEmploymentStatus: 'Please select their type of employment',
	otherEmploymentType: 'Please select their employment status',
	studentOccupation: 'Please search for and select their education type',
	otherIndustry: 'Please search for and select their other industry',
	licenceType: 'Please select their licence type',
	licenceObtained: 'Please enter their licence date',
	hasMotoringConvictions: 'Please confirm if they have any motoring convictions',
	motoringConvictionsMin: 'Please add at least one conviction or select no to the above question',
	hasMotoringClaims: 'Please confirm if they have made any claims in the last five years',
	motoringClaims: 'Please add at least one claim or select no to the above question',
	hasCriminalConvictions: 'Please confirm if they have any criminal convictions',
	hasBeenRefusedCover: 'Please confirm if they have ever been refused cover',
	dlnRequired: 'Driver licence number is required',
	dlnValid: 'Please enter a valid UK driver licence number',
	driverUsageRequired: 'Please select badge type.',
	driverUsageSDP:
		'We will be unable to cover additional drivers for social, domestic and pleasure usage unless your vehicle is licenced by London PCO',
};

export const DRIVER_ERRORS = {
	employmentType: 'Please select the type of employment you have',
	occupation: 'Please search for and select your main occupation',
	industry: 'Please search for and select your main industry',
	otherEmployment: 'Please confirm if you have another occupation',
	otherOccupation: 'Please search for and select your other occupation',
	otherEmploymentStatus: 'Please select your type of employment',
	otherEmploymentType: 'Please select your employment status',
	studentOccupation: 'Please search for and select your education type',
	otherIndustry: 'Please search for and select your other industry',
	driverUsageRequired: 'Please select badge type.',
};

export const TAXI_ERRORS = {
	badgeObtained: 'Please select when you obtained your badge',
	badgeObtainedAdditional: 'Please select when they obtained their badge',
	renewalDate: 'Please select when you would like to start your policy',
	licensingAuthority: 'Please select your licensing authority',
	operatingArea: 'Please select your operating area',
	publicUsage: 'This vehicle is not licensed for public hire.',
};

// Shared error messages that don't change between main driver and additional driver
const MOTORING_CLAIMS_COMMON_ERRORS = {
	typeOfClaim: 'Please select the type of the claim',
	statusOfClaim: 'Please select the status of the claim',
	costOfClaim: 'Please enter the cost of the claim',
	costOfClaimGreaterOrEqualToZero: 'Cost of claim must cannot be a negative number',
};

export const MOTORING_CLAIMS_ERRORS = {
	...MOTORING_CLAIMS_COMMON_ERRORS,
	dateOfClaim: 'Please enter the date of the claim',
	atFault: 'Please confirm if you were at fault',
	noClaimsBonusAffected: 'Please confirm if your No Claims Bonus was affected',
};

export const ADDITIONAL_DRIVER_MOTORING_CLAIMS_ERRORS = {
	...MOTORING_CLAIMS_COMMON_ERRORS,
	dateOfClaim: 'Please select their date of claim',
	atFault: 'Please confirm if they were at fault',
	noClaimsBonusAffected: 'Please confirm if their No Claims Bonus was affected',
};

// Shared error messages that don't change between main driver and additional driver
export const MOTORING_CONVICTIONS_COMMON_ERRORS = {
	convictionDate: 'Please select the date of the conviction',
	convictionDateBefore: 'Conviction date cannot be before offence date',
	banDateBeforeDate: 'Ban start date cannot be before conviction date',
	dateOfOffence: 'Please select the date of the offence',
	endDateBeforeStart: 'End Date must be after Start date',
	offenceCode: 'Please select the offence code',
	fineAmount: 'Please enter the fine amount',
	isPending: 'Please confirm if the conviction is pending or not',
};

export const MOTORING_CONVICTIONS_ERRORS = {
	...MOTORING_CONVICTIONS_COMMON_ERRORS,
	wasDisqualified: 'Please confirm if you were disqualified',
	banStartDate: 'Please enter the date your ban started',
	banEndDate: 'Please enter the date your ban ended',
	numberOfPoints: 'Please select how many points you obtained',
};

export const ADDITIONAL_DRIVER_MOTORING_CONVICTIONS_ERRORS = {
	...MOTORING_CONVICTIONS_COMMON_ERRORS,
	wasDisqualified: 'Please confirm if they were disqualified',
	banStartDate: 'Please enter the date their ban started',
	banEndDate: 'Please enter the date their ban ended',
	numberOfPoints: 'Please select how many points they obtained',
};

export const VEHICLE_DETAILS_PART_TWO_ERROR_MESSAGES = {
	valueMaxAmount: "Value can't greater than £1,000,000",
	valueRequired: 'Please enter the value of the vehicle',
	leftHandDrive: 'Please confirm if the vehicle is left hand drive',
	purchaseDate: 'Please select the date of purchase',
	purchaseMinDate: 'The year of purchase cannot be earlier than the year of manufacture.',
	purchaseMaxDate: 'The date of purchase cannot be in the future.',
	isLegalOwner: 'Please confirm if you are the legal owner of the vehicle',
	vehiclePurchased: 'Please confirm if you have purchased the vehicle',
	isRegisteredKeeper: 'Please confirm if you are the registered keeper of the vehicle',
	imported: 'Please confirm if the vehicle is imported',
	countryOfRegistration: 'Please select the country of registration',
	owner: 'Please select the legal owner',
	keeper: 'Please select the registered keeper',
	keptOvernight: 'Please verify where the vehicle is kept overnight',
	hasModifications: 'Please confirm if the vehicle has any modifications',
	modifications: 'Please add at least one modification',
	vehicleUse: "Please select the best option that describes the vehicle's use",
	annualMileageGreaterThanZero: 'Annual Mileage must be greater than zero',
	annualMileageRequired: 'Please enter your annual mileage',
	businessMileageGreaterThanZero: 'Business Mileage must be greater than zero',
	businessMileageRequired: 'Please enter your annual business mileage',
	assumptionAgree: 'Please confirm the statements',
	businessRadius: 'Please confirm business radius',
	hasInternalRacking: 'Please confirm if vehicle has internal racking',
	vehicleCarriesDangerousGoods: 'Please confirm if vehicle carries dangerous goods',
	vehicleVisitsHazardousSites: 'Please confirm if vehicle visits hazardous sites',
	telematicFitted: 'Please confirm if a telematic box has been fitted',
	bodyType: 'Please select a body type',
	levelOfCover: 'Please select a level of cover',
};

export const PAYMENT_SUMMARY_ERRORS = {
	accountHolder: 'Please provide the account holder name',
	accountHolderMin: 'Account holder name must be longer than 3 characters',
	accountHolderValid: 'Account holder name cannot begin or end with special characters or include numbers',
	accountNumber: 'Please enter a valid account number',
	sortCodeValid: 'Please enter a valid sort code',
	sortCode: 'Please enter a sort code',
	affordableLending: 'Please confirm if you can afford the repayments',
	affordableLendingNo:
		'In order to continue with your policy purchase, you must confirm to us that you can afford the repayments.',
	premiumFinanceNo:
		'In order to continue with your policy purchase, you must confirm to us that you wish to obtain premium finance.',
	premiumFinance: 'Please confirm that you wish to obtain premium finance',
	isAccountHolder: 'Please select if you are the account holder',
	isAccountHolderNo:
		'Unfortunately, as you are not the account holder we are unable to proceed with this change. The Direct Debit will need to be set up in the Policy Holders name to proceed.',
	isOnlySignatoryRequired: 'Please select if you are the only signatory required',
	isOnlySignatoryRequiredNo:
		'Unfortunately, as you have a joint signatory account we are unable to proceed with this change. The Direct Debit will need to be set up in the Policy Holders name to proceed.',
	detailsCorrect: 'Please confirm that all the details above are correct and you agree with the Terms and Conditions',
	bankDetailsNetworkError: 'Error retrieving bank account details, please delete and re-enter details',
	bankDetailsNotValid: 'Bank account not found, please try again with other details',
	bankName: 'Please provide your bank name',
	collectionDay: 'Please select your new collection day',
};

export const EXISTING_CARD_PAYMENT_ERRORS = {
	id: 'Please select a card',
};

export const VERIFY_ACCOUNT_ERRORS = {
	dateOfBirth: 'Please enter your date of birth',
	vehicleRegistrationNumber: 'Please enter your vehicle registration',
};

export const CHANGE_MILEAGE_USAGE_ERRORS = {
	vehicleUse: "Please select the best option that describes the vehicle's use",
	levelOfCover: 'Please select the type of cover you require',
	annualMileage: 'Please enter your annual mileage',
	businessMileage: 'Please enter your business mileage',
};

export const CANCELLATION_DATE_ERRORS = {
	cancellationDateDescriptionRequired: 'Select an option before continuing.',
	cancellationDateRequired: 'Select a date before continuing.',
	cancellationTimeRequired: 'Select a time before continuing.',
	cancellationDateNotInPast: 'Your selected date cannot be in the past.',
};

export default {};
